// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__8gBwP","buttons":"RemoveExpirationActionButtons_buttons__2lr3J"};